export const getImageWithWidth = (url, width) =>
  url ? url.replace('w=1800', `w=${width}`).replace('h=1800', '') : '';

const getSrcSetEntry = (url, width) =>
  `${getImageWithWidth(url, width)} ${width}w`;

export const getSrcSet = (url, widths = []) =>
  widths.map(width => getSrcSetEntry(url, width)).join(', ');
